@if (!oneDayVeranstaltung()) {
  <span>{{datumVon | date: getFromDateFormatterString()}} bis {{datumBis | date: getDateFormatterString()}}</span>
}
@if (oneDayVeranstaltung()) {
  <span>{{datumBis | date: getDateFormatterString()}}</span>
}
